<template>
    <modal-wrapper modalClass="modal--small" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-text="content.title"></h1>
        </div>
        <div class="modal__content" v-text="content.message">
        </div>
        <div class="modal__footer">
            <div class="actions">
                <button class="actions__action--save pull-right" type="submit" v-text="content.confirmText " @click="confirm"></button>
                <button class="actions__action--cancel" type="button" v-text="content.cancelText" @click="cancel"></button>
            </div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    @Component
    export default class ConfirmationModal extends Vue {
        name = 'confirmation-modal';

        content = {};

        eventData = null;
        callback = null;

        beforeOpen(event) {
            // Default modal content; it can be overriten on modal show
            this.content = {
                title: 'Confirm',
                message: 'Are you sure that you want to delete this item?',
                confirmText: this.$t('modals.common.confirm'),
                cancelText: this.$t('modals.common.cancel'),
            };

            let { content, callback, ...eventData } = event.params;
            this.content = {...this.content, ...content};
            this.callback = callback;
            this.eventData = eventData;
        }

        confirm() {
            this.$modal.hide(this.name);
            this.callback(this.eventData);
        }

        cancel() {
            this.$modal.hide(this.name);
        }
    }

    Vue.component('confirmation-modal', ConfirmationModal);
</script>



// WEBPACK FOOTER //
// src/components/modals/ConfirmationModal.vue